module.exports = __webpack_public_path__ + "static/media/velocity-video-2.74e13b23.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/VelocityTest/velocity-video-2.mp4
// module id = 3613
// module chunks = 0